import { __extends } from "tslib";
import { BitmapFilter } from './BitmapFilter';
import { NumberUtilities } from '@awayfl/swf-loader';
var BlurFilter = /** @class */ (function (_super) {
    __extends(BlurFilter, _super);
    function BlurFilter(blurX, blurY, quality) {
        if (blurX === void 0) { blurX = 4; }
        if (blurY === void 0) { blurY = 4; }
        if (quality === void 0) { quality = 1; }
        var _this = _super.call(this) || this;
        _this.filterName = 'blur';
        _this.blurX = blurX;
        _this.blurY = blurY;
        _this.quality = quality;
        return _this;
    }
    BlurFilter.FromUntyped = function (obj, sec) {
        return new sec.flash.filters.BlurFilter(obj.blurX, obj.blurY, obj.quality);
    };
    Object.defineProperty(BlurFilter.prototype, "blurX", {
        get: function () {
            return this._blurX;
        },
        set: function (value) {
            this._blurX = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "blurY", {
        get: function () {
            return this._blurY;
        },
        set: function (value) {
            this._blurY = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "quality", {
        get: function () {
            return this._quality;
        },
        set: function (value /*int*/) {
            this._quality = NumberUtilities.clamp(value | 0, 0, 15);
        },
        enumerable: true,
        configurable: true
    });
    BlurFilter.prototype.clone = function () {
        return new this.sec.flash.filters.BlurFilter(this._blurX, this._blurY, this._quality);
    };
    BlurFilter.prototype.toAwayObject = function () {
        return this;
    };
    // Called whenever the class is initialized.
    BlurFilter.classInitializer = null;
    // List of static symbols to link.
    BlurFilter.classSymbols = null; // [];
    // List of instance symbols to link.
    BlurFilter.instanceSymbols = null;
    return BlurFilter;
}(BitmapFilter));
export { BlurFilter };
